export default __webpack_public_path__ + "static/media/casino-icon-GJ.3c2ecf9d.gif";